import type { ConditionDefinition, GameState } from '../types';

export class ConditionEvaluator {
  evaluate(condition: ConditionDefinition, state: Readonly<GameState>): boolean {
    switch (condition.type) {
      case 'flag':
        return state.flags[condition.key] === condition.equals;
      case 'hasItem':
        return state.inventory.includes(condition.itemId);
      case 'missingItem':
        return !state.inventory.includes(condition.itemId);
      case 'selectedItem':
        return state.selectedItemId === condition.itemId;
      case 'sceneState':
        return state.sceneState[condition.sceneId]?.[condition.key] === condition.equals;
      case 'locationUnlocked':
        return state.unlockedLocations.includes(condition.locationId);
      case 'all':
        return condition.conditions.every((entry) => this.evaluate(entry, state));
      case 'any':
        return condition.conditions.some((entry) => this.evaluate(entry, state));
      case 'not':
        return !this.evaluate(condition.condition, state);
    }
  }

  evaluateAll(conditions: ConditionDefinition[] | undefined, state: Readonly<GameState>): boolean {
    return conditions?.every((condition) => this.evaluate(condition, state)) ?? true;
  }
}
